<template>
  <div
    style="
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
    "
  >
    <div style="display: flex; height: 80px">
      <div
        style="
          width: 200px;
          border-radius: 10px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <el-image
          :src="require('@/assets/images/home-logo.png')"
          style="height: 80%"
        />
      </div>
      <div
        style="
          flex: 1;
          border-radius: 10px;
          background-color: #fff;
          margin-left: 15px;
          display: flex;
        "
      >
        <li style="flex: 1">
          <text
            style="
              line-height: 80px;
              margin-left: 20px;
              font-weight: 600;
              font-size: 24px;
            "
            class="shine"
          >
            {{ $store.state.loginUser?.name }}
          </text>
        </li>
        <el-dropdown style="height: 100%">
          <div
            style="
              display: flex;
              align-items: center;
              height: 100%;
              outline: none;
              cursor: pointer;
            "
          >
            <el-icon style="margin-right: 5px" size="20"><User /></el-icon>
            <text style="color: #4e4e4b; font-size: 16px">{{
              $store.state.loginUser?.contact_name
            }}</text>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                style="color: #f00"
                @click="router.push('/editpass')"
                >修改密码</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <li
          class="header-logout"
          @click="onLogout"
          style="
            margin-left: 40px;
            background-color: #004890;
            color: #fff;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            padding: 0 20px;
          "
        >
          <el-icon :size="17" style="margin-right: 2px"
            ><SwitchButton
          /></el-icon>
          退出
        </li>
      </div>
    </div>
    <div style="flex: 1; display: flex; margin-top: 15px; overflow: hidden">
      <div
        style="
          width: 200px;
          border-radius: 10px;
          background-color: #004890;
          padding: 0 10px;
        "
      >
        <ul
          class="menu-ul"
          :class="route.path == '/employee' ? 'menu-ul-active' : ''"
          @click="router.push('/employee')"
        >
          <el-icon :size="16" color="#fff"><UserFilled /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            员工花名册
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/subaccount')"
          :class="route.path == '/subaccount' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><Share /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            子账户
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/payroll')"
          :class="route.path == '/payroll' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><Histogram /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            工资表
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/bankreceived')"
          :class="route.path == '/bankreceived' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><List /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            转款记录
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/invoice')"
          :class="route.path == '/invoice' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><Stamp /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            开票记录
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/template')"
          :class="route.path == '/template' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><Platform /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            模板管理
          </text>
        </ul>
        <ul
          class="menu-ul"
          @click="router.push('/info')"
          :class="route.path == '/info' ? 'menu-ul-active' : ''"
        >
          <el-icon :size="16" color="#fff"><HomeFilled /></el-icon>
          <text style="margin-left: 10px; font-size: 14px; color: #fff">
            企业信息
          </text>
        </ul>
      </div>
      <li
        style="
          flex: 1;
          border-radius: 10px;
          background-color: #fff;
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
        "
      >
        <div
          style="
            border-bottom: 1px solid #e2e2e2;
            padding: 10px;
            font-weight: 600;
          "
        >
          {{ route.meta?.title }}
        </div>
        <div style="flex: 1; overflow: hidden">
          <transition name="el-fade-in-linear">
            <router-view />
          </transition>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { home_getuser } from "@/http/api";
import store from "@/store";
export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({});
    onMounted(() => {
      console.log(route);
      home_getuser().then((res) => {
        if (res.status == 200) {
          store.commit("setLoginUser", res.data.data);
        }
      });
    });
    return { state, route, router };
  },
};
</script>
<style lang="less">
.header-logout {
  display: flex;
  align-items: center;
  width: 80px;
  font-size: 12px;
  cursor: pointer;
  color: #4e4e4b;
  border-radius: 10px;

  &:hover {
    color: #27a6d8;
  }
}

.menu-ul {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-radius: 10px;
  margin-top: 15px;
  cursor: pointer;
  &:hover {
    background-color: #336da6;
  }
}

.menu-ul-active {
  background-color: #336da6;
}

.shine {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  letter-spacing: 4px;
  text-shadow: 0 5px 3px rgba(0, 0, 0, 0.2);
}
</style>
